import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { DomainService } from '../domain/domain.service';

type CommunityLookup = {
  data?: { id?: number; space_id?: number; community_url?: string; Spaces?: { id?: number } };
};

const BY_SLUG_ENDPOINT = (slug: string) =>
  `${environment.apiUrl}/communities/${encodeURIComponent(slug)}`;

function isPublicChildPath(route: ActivatedRouteSnapshot): boolean {
  const p = (route.routeConfig?.path || '').toLowerCase();
  return (
    p === 'login' ||
    p.startsWith('registration') ||
    p === 'forgot-password' ||
    p.startsWith('reset-password')
  );
}

export const SpaceResolver: ResolveFn<boolean> = async (route: ActivatedRouteSnapshot) => {
  const http = inject(HttpClient);
  const domain = inject(DomainService);

  if (!domain.isCommunityDomain()) return true;

  const slug = (route.paramMap.get('slug') || '').trim();
  const cid: number = Number(route.paramMap.get('communityId') || 0) || 0; // always a number

  if (slug) localStorage.setItem('slug', slug);
  if (cid) localStorage.setItem('communityId', String(cid));

  // Set context early with numeric fallbacks (no undefineds)
  try {
    domain.setContext?.(slug, cid, 0);
  } catch {}

  if (!slug || isPublicChildPath(route)) return true;

  try {
    const res = await firstValueFrom(http.get<CommunityLookup>(BY_SLUG_ENDPOINT(slug)));
    const sid: number =
      Number(res?.data?.space_id || res?.data?.Spaces?.id || 0) || 0;

    if (sid) sessionStorage.setItem('pendingSpaceID', String(sid));
    sessionStorage.setItem('pendingSlug', slug);
    if (cid) sessionStorage.setItem('pendingCommunityId', String(cid));

    // Reflect into DomainService (read-only), again with numeric values only
    domain.setContext?.(slug, cid, sid);
  } catch {
    // let guard handle fallbacks
  }

  return true;
};
